import React from 'react';
// import {getSampleFiles} from "./samples";

// const sampleFiles = getSampleFiles()

type StepProps = {
    step: number;
    activeStep: number;
    slices: number[];
    samples: number[];
    retrigs: number[];
    playerTypes: ('normal' | 'hi' | 'lo' | 'reverse')[];
    locks: boolean[];
};

// const beatChars = ['', '', '', '']
const stepChars = ['', '', '', '', '', '', '', ''];

function Step(props: StepProps) {
    const retrigs = props.retrigs[props.step]
    const playerType = props.playerTypes[props.step]

    return <div
        className={`step ${(props.step + 1) % 4 === 0 ? 'mb-3' : ''} ${props.slices[props.step] === -1 ? 'muted' : ''}`}>

        <span className={`me-3 ${props.activeStep === props.step ? '' : 'muted'}`}>
            {String(props.step + 1).padStart(2, '0')}
        </span>

        <span className={`me-2 ${props.activeStep === props.step ? '' : 'muted'}`}>
            {(props.samples[props.step] ?? 0) + 1}
        </span>

        <span className="me-3">
            {Array.from(Array(8).keys()).map(i => <span
                    key={`step-${props.step}-slice-${i}`}
                    className={`selector me-2 slice ${props.slices[props.step] % 8 === i ? '' : 'muted'}`}
                >{stepChars[i]}</span>
            )}
        </span>

        <span className={`me-3 ${props.slices[props.step] > 7 ? '' : 'muted'}`}>↑</span>

        <span className="me-1">
            {retrigs > 0 ? `R${retrigs}` : '--'}
        </span>
        <span className="me-2">
            {playerType !== 'normal' ? `P${playerType.substring(0, 1).toUpperCase()}` : '--'}
        </span>

        {props.step % 4 === 0 &&
          <span className={`${props.locks[Math.floor(props.step / 4)] ? '' : 'muted'}`}></span>
        }

    </div>
}

export default Step
